/** @jsx jsx */
import { jsx, Box, Flex } from 'theme-ui';
import React, { FunctionComponent } from 'react';

// Styles
import { baseStyle } from './style';

const PlayerLightIcon: FunctionComponent = React.memo(() => (
  <Flex sx={baseStyle.iconContainer}>
    <Box sx={baseStyle.icon} />
  </Flex>
));

export default PlayerLightIcon;
